import { render } from "./ReferidosMesActual.vue?vue&type=template&id=6f2e29de"
import script from "./ReferidosMesActual.vue?vue&type=script&lang=js"
export * from "./ReferidosMesActual.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__